import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5e9c77be&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=5e9c77be&prod&lang=scss&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=5e9c77be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c77be",
  null
  
)

export default component.exports